module.exports = __webpack_public_path__ + "img/checkmark.111166bb.svg";